var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEmpty)?_c('div',{staticClass:"cc-video cc-video-empty",style:(_vm.emptyVideoStyle)}):_c('div',{staticClass:"cc-video"},[_c('div',{directives:[{name:"impr",rawName:"v-impr",value:(_vm.reportInfo.id),expression:"reportInfo.id"}],ref:"video",staticClass:"bilibiliPlayer cc-video",attrs:{"impr-data":JSON.stringify(_vm.reportInfo)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }